<template>
  <section
    class="app-main"
    :style="{
      height: $route.meta.appMainMinHeight || 'calc(100vh - 106px)',
    }"
  >
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view v-if="!$route.meta.link" :key="key" />
      </keep-alive>
    </transition>
    <iframe-toggle />
  </section>
</template>

<script>
  import iframeToggle from './IframeToggle/index';
  import Breadcrumb from '@/components/Breadcrumb';
  import { mapState } from 'vuex';

  export default {
    name: 'AppMain',
    components: { iframeToggle, Breadcrumb },
    computed: {
      ...mapState({
        topNav: (state) => state.settings.topNav,
      }),
      cachedViews() {
        return this.$store.state.tagsView.cachedViews;
      },
      key() {
        return this.$route.path;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .app-main {
    /* 50= navbar  50  */
    min-height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    overflow: hidden;
  }

  .breadcrumb-appmain {
    display: block;
    padding: 10px 20px 0;
  }

  .fixed-header + .app-main {
    padding-top: 50px;
  }

  .hasTagsView {
    .app-main {
      /* 84 = navbar + tags-view = 50 + 34 */
      min-height: calc(100vh - 106px);
      overflow: auto;
    }

    .fixed-header + .app-main {
      padding-top: 84px;
    }
  }
</style>

<style lang="scss">
  // fix css style bug in open el-dialog
  .el-popup-parent--hidden {
    .fixed-header {
      padding-right: 6px;
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #c0c0c0;
    border-radius: 3px;
  }
</style>
